import Vue from "vue";
import i18n from "@/plugins/i18n";

const END_POINT = "/admin/stakeholders";

const getAdminStakeholder = (stakeholderType, stakeholderId, params = {}) =>
  Vue.axios.get(`${END_POINT}/${stakeholderType}/${stakeholderId}`, {
    params: params
  });

const getServices = () => {
  return [
    {
      id: 1,
      name: i18n.t("admin.form.surveyflow.surveyflows.awareness"),
      service: "awareness"
    },
    {
      id: 2,
      name: i18n.t("admin.form.surveyflow.surveyflows.wellbeing"),
      service: "wellbeing"
    },
    {
      id: 3,
      name: i18n.t("admin.form.surveyflow.surveyflows.risk"),
      service: "risk"
    },
    {
      id: 4,
      name: i18n.t("admin.form.surveyflow.surveyflows.phishing"),
      service: "phishing"
    },
    {
      id: 5,
      name: i18n.t("admin.form.surveyflow.surveyflows.abs"),
      service: "gaming"
    },
    {
      id: 6,
      name: i18n.t("admin.form.surveyflow.surveyflows.federation"),
      service: "federation"
    },
    {
      id: 7,
      name: i18n.t("admin.form.surveyflow.surveyflows.neurophishing"),
      service: "neurogaitas"
    },
    {
      id: 8,
      name: i18n.t("admin.form.surveyflow.surveyflows.burnout"),
      service: "burnout"
    },
    {
      id: 9,
      name: i18n.t("admin.form.surveyflow.surveyflows.scim"),
      service: "scim"
    },
    {
      id: 10,
      name: i18n.t("admin.form.surveyflow.surveyflows.smishing"),
      service: "smishing"
    },
    {
      id: 11,
      name: i18n.t("admin.form.surveyflow.surveyflows.neurosmishing"),
      service: "smishgaitas"
    },
    {
      id: 12,
      name: i18n.t("admin.form.surveyflow.surveyflows.impact"),
      service: "impact"
    },
    {
      id: 13,
      name: i18n.t("admin.form.surveyflow.surveyflows.socialengineering"),
      service: "socialengineering"
    },
    {
      id: 14,
      name: i18n.t("admin.form.surveyflow.surveyflows.archetype"),
      service: "archetype"
    }
  ];
};

const updateStakeholder = (stakeholderType, stakeholderId, payload) =>
  Vue.axios.put(`${END_POINT}/${stakeholderType}/${stakeholderId}`, payload);
const updateStakeholders = (stakeholderType, payload) =>
  Vue.axios.put(`${END_POINT}/multiupdate/${stakeholderType}`, payload);
const updateStakeholderLogo = (stakeholderType, stakeholderId, payload) =>
  Vue.axios.post(`${END_POINT}/${stakeholderType}/${stakeholderId}`, payload, {
    "Content-Type": "multipart/form-data"
  });
const sendWellcomeMail = (stakeholderId, payload) =>
  Vue.axios.post(`${END_POINT}/emails/${stakeholderId}`, payload);
const deleteStakeholder = (stakeholderType, stakeholderId) =>
  Vue.axios.delete(`${END_POINT}/${stakeholderType}/${stakeholderId}`);
const deleteStakeholders = (stakeholderType, payload) =>
  Vue.axios.put(`${END_POINT}/multidelete/${stakeholderType}`, payload);
const deleteCompanyChildren = (stakeholderType, stakeholderId) =>
  Vue.axios.delete(`${END_POINT}/${stakeholderType}/${stakeholderId}`);
const createStakeholder = (stakeholderType, payload) =>
  Vue.axios.post(`${END_POINT}/${stakeholderType}`, payload);
const getDepartments = (stakeholderId, params = {}) =>
  Vue.axios.get(`${END_POINT}/companies/${stakeholderId}/departments`, {
    params: params
  });
const getUsers = (stakeholderType, stakeholderId, params = {}) =>
  Vue.axios.get(`${END_POINT}/${stakeholderType}/${stakeholderId}/people`, {
    params: params
  });
const getCompanies = (stakeholderId, params = {}) =>
  Vue.axios.get(`${END_POINT}/companies/${stakeholderId}/companies`, {
    params: params
  });
const reactiveStakeholder = stakeholderId =>
  Vue.axios.patch(`${END_POINT}/people/${stakeholderId}`);

export {
  getServices,
  getAdminStakeholder,
  updateStakeholder,
  updateStakeholders,
  updateStakeholderLogo,
  deleteStakeholder,
  deleteStakeholders,
  deleteCompanyChildren,
  sendWellcomeMail,
  createStakeholder,
  getDepartments,
  getUsers,
  getCompanies,
  reactiveStakeholder
};
